var render = function render(){var _vm=this,_c=_vm._self._c;return _c('stripe-element',{ref:"element",attrs:{"type":"cardCvc","stripe":_vm.stripe,"value":_vm.value,"options":_vm.options},on:{"blur":function($event){return _vm.$emit("blur")},"focus":function($event){return _vm.$emit("focus")},"change":function($event){return _vm.$emit("change", $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }